import React, { useEffect, useState, useRef} from 'react';
import './ImageSearch.scss'
import { fetchSubTiles, setSelectedSource, setUpThirdPartyLibraries, setUpThirdPartyLibrariesSearch } from './redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { LibrarySourceType } from './types/ThirdPartyLibrary';
import { fbdata } from '../redux/reducers/fbdata';
import { FilterDropdown } from './FilterDropdown';

export const ImageSearch = ({source}: {source?:LibrarySourceType})=>{
    const[searchQuery, setSearchQuery] = useState(undefined as any)
    const ref = useRef(undefined as any);

    const dispatch = useDispatch();

    useEffect(()=>{
        if(!source?.endsWith('_searchResults')){
            ref.current.value = '';
        }
    },[source])

    useEffect(()=>{
        if(searchQuery && searchQuery.length > 3){
            dispatch(setSelectedSource('patternDesigns_searchResults'))
            dispatch(setUpThirdPartyLibrariesSearch('patternDesigns_searchResults',searchQuery))
            dispatch(fetchSubTiles('patternDesigns_searchResults',{
                id: searchQuery,
                isCategory:true,
                isPatternContainer:true,
                name:searchQuery,
                term:searchQuery,
            }, 0))
        }
    },[searchQuery])

    return <input ref={ref} type='text' className='library-search-box' onChange={(event)=>{
        setSearchQuery(event.target.value);
    }} />
}